export function formatSecondsToMinutes(seconds?: number): string {
    if (seconds === undefined || seconds === 0) {
        return '0:00';
    }

    //round up to nearest second
    seconds = Math.ceil(seconds);

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}
